(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mt-image-with-text-special"] && !Shopify.designMode) return;
  try {
    
  function startMarquee(id, pathId, content, speed) {
            const textPath = document.getElementById(id);
            const path = document.getElementById(pathId);
            const pathLength = path.getTotalLength();
            textPath.innerHTML = content;

            let offset = 0;

            function animateText() {
                offset -= speed;
                if (offset < 0) {
                    offset = pathLength;
                } else if (offset > pathLength) {
                    offset = 0;
                }
                textPath.setAttribute('startOffset', `${offset}px`);
                requestAnimationFrame(animateText);
            }

            animateText();
        }

        document.addEventListener('DOMContentLoaded', () => {
            const textContent1 = '<a href="#" target="_blank" style="text-decoration: none;">Stronger. Softer. Shinier. Confidence Starts Here. Your Best Hair Awaits. &nbsp;&nbsp;&nbsp;&nbsp;</a>'.repeat(20);
            startMarquee('marquee-text', 'text-path', textContent1, -2);

          

        });




  } catch(e) { console.error(e); }
})();
})();
